import { lazy } from 'react'
import type { RouteObject } from 'react-router'
import { Outlet } from 'react-router-dom'
import { IssuerGuard } from '@/guards/issuer-guard'
import { GuestGuard } from '@/guards/guest-guard'
import { Issuer } from '@/types/auth'
import { Layout as AuthModernLayout } from '@/layouts/auth/modern-layout'
import { wrapWithErrorBoundary } from '@/routes/wrapWithErrorBoundary'

// JWT
const JwtLoginPage = lazy(() => import('@/pages/auth/jwt/login'))
const JwtForgotPasswordPage = lazy(
  () => import('@/pages/auth/jwt/forgot-password')
)
const JwtRenewPasswordPage = lazy(
  () => import('@/pages/auth/jwt/renew-my-password')
)
const JwtNewNaberPage = lazy(() => import('@/pages/auth/jwt/new-naber'))
const McpOAuthConsentPage = lazy(() => import('@/pages/McpOAuthConsent'))
const ImpersonatePage = lazy(() => import('@/pages/auth/impersonate'))

const WrappedJwtLoginPage = wrapWithErrorBoundary(JwtLoginPage)
const WrappedJwtForgotPasswordPage = wrapWithErrorBoundary(
  JwtForgotPasswordPage
)
const WrappedJwtRenewPasswordPage = wrapWithErrorBoundary(JwtRenewPasswordPage)
const WrappedJwtNewNaberPage = wrapWithErrorBoundary(JwtNewNaberPage)
const WrappedMcpOAuthConsentPage = wrapWithErrorBoundary(McpOAuthConsentPage)
const WrappedImpersonatePage = wrapWithErrorBoundary(ImpersonatePage)

export const authRoutes: RouteObject[] = [
  {
    path: 'oauth/mcp/consent',
    element: (
      <AuthModernLayout>
        <WrappedMcpOAuthConsentPage />
      </AuthModernLayout>
    ),
    handle: {
      documentTitle: { namespace: 'nav', key: 'mcpConsent' },
    },
  },
  {
    // Sans garde : le SUPERADMIN arrive de la console, connecté ou non à la webapp.
    path: 'impersonate',
    element: (
      <AuthModernLayout>
        <WrappedImpersonatePage />
      </AuthModernLayout>
    ),
    handle: {
      documentTitle: { namespace: 'nav', key: 'impersonate' },
    },
  },
  {
    path: 'auth',
    children: [
      {
        path: 'jwt',
        element: (
          <IssuerGuard issuer={Issuer.JWT}>
            <GuestGuard>
              <AuthModernLayout>
                <Outlet />
              </AuthModernLayout>
            </GuestGuard>
          </IssuerGuard>
        ),
        children: [
          {
            path: 'login',
            element: <WrappedJwtLoginPage />,
            handle: {
              documentTitle: { namespace: 'nav', key: 'login' },
            },
          },
          {
            path: 'forgot-password',
            element: <WrappedJwtForgotPasswordPage />,
            handle: {
              documentTitle: { namespace: 'nav', key: 'forgotPassword' },
            },
          },
          {
            path: 'renew-my-password',
            element: <WrappedJwtRenewPasswordPage />,
            handle: {
              documentTitle: { namespace: 'nav', key: 'resetPassword' },
            },
          },
          {
            path: 'new-naber',
            element: <WrappedJwtNewNaberPage />,
            handle: {
              documentTitle: { namespace: 'nav', key: 'register' },
            },
          },
        ],
      },
    ],
  },
]
